import './whoAreWeTxt.css';

const WhoAreWeTxt = () => (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', marginTop: '-35rem', position: 'relative' }}> 
        <p class="who_are_we" style={{ color: "#0000FF", textAlign: "left", marginLeft: "-39%" }}>
          At Timeline Estudio, we turn ideas into stories that connect.<br />
          We’re a creative marketing and advertising agency dedicated to making your life easier when it comes to social media.<br />
          Our mission is to help your business build a strong digital presence, so you’re not wasting money on ads that don’t deliver results.<br />
          We create valuable, high-performing content designed to position your brand for success through creativity and innovation.
        </p>
    </div>
);

export default WhoAreWeTxt;